import React from "react";

export default React.memo(function FavQntIcon() {
    return (
        <svg
            width="16"
            height="14"
            viewBox="0 0 16 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.156 1.52512C13.3191 0.68848 12.196 0.229516 11.0324 0.250702C9.85921 0.251292 8.79244 1.00841 8.01439 1.85556C7.22828 1.00801 6.1475 0.251288 4.96753 0.250702C3.80393 0.229516 2.68085 0.68848 1.84397 1.52512C1.00696 2.36188 0.5243 3.50813 0.5 4.7123V4.71525C0.5 5.9193 0.971297 7.00358 1.73597 7.80629L1.94233 8.00487L7.49903 13.5314C7.78087 13.8229 8.24923 13.8229 8.531 13.5312L14.0647 7.99755C14.5146 7.58752 14.875 7.08305 15.1223 6.51786C15.3701 5.9516 15.4988 5.33718 15.5 4.71552L15.4999 4.7123C15.4756 3.50813 14.993 2.36188 14.156 1.52512Z"
                fill="#DA3832"
            />
        </svg>
    );
});